import React, { PureComponent } from 'react';
import { Translate } from 'react-redux-i18n';

class PacksImportErrors extends PureComponent {
  render() {
    const { errorKey, errorParams, errors } = this.props;

    if ((!errors || !errors.length) && !errorKey) return null;

    return (
      <div className="clients-errors">
        <hr />
        <h5 style={{ color: 'red' }}>
          <strong><Translate value="packsNotAdded" /></strong>
        </h5>

        {errors && errors.length ? (
          <React.Fragment>
            <p><Translate value="importPacksError_ValidationFailed" /></p>
            <ul>
              {errors.map((error, index) => {
                const {
                  packName, line, code, messageKey,
                } = error;
                const location = [
                  packName && `Pack "${packName}"`,
                  line ? `Línea ${line}` : null,
                ].filter(Boolean).join(' — ');

                return (
                  // eslint-disable-next-line react/no-array-index-key
                  <li key={`${messageKey}-${index}`}>
                    {location && <strong>{location}: </strong>}
                    <Translate value={messageKey} code={code} dangerousHTML />
                  </li>
                );
              })}
            </ul>
          </React.Fragment>
        ) : (
          <p><Translate value={errorKey} {...errorParams} dangerousHTML /></p>
        )}
      </div>
    );
  }
}

export default PacksImportErrors;
